/**
 * Labstep
 *
 * @module components/PurchaseOrder/Filter/Status/Select
 * @desc Filter for PurchaseOrder status as select
 */

import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import { ModalDefaultContainer as Modal } from 'labstep-web/core/Modal/Default';
import { Select as ReactSelect } from 'labstep-web/core/Select';
import { PurchaseOrderStatusValues } from 'labstep-web/models/purchase-order.model';
import type React from 'react';
import { placeholder } from './strings';
import type { IPurchaseOrderFilterStatusSelectProps } from './types';

export const PurchaseOrderFilterStatusSelect: React.FC<
  IPurchaseOrderFilterStatusSelectProps
> = ({ setParams, searchParams }) => (
  <Modal
    header={'Status'}
    content={({ toggleModal }) => (
      <ReactSelect
        defaultValue={
          searchParams.status
            ? {
                value: searchParams.status,
                label:
                  PurchaseOrderStatusValues[
                    searchParams.status as keyof typeof PurchaseOrderStatusValues
                  ],
              }
            : null
        }
        options={Object.keys(PurchaseOrderStatusValues).map(
          (key) => ({
            value: key,
            label:
              PurchaseOrderStatusValues[
                key as keyof typeof PurchaseOrderStatusValues
              ],
          }),
        )}
        isClearable
        onChange={(
          selectedOption: {
            value: string;
            label: string;
          } | null,
        ) => {
          setParams({
            status: selectedOption ? selectedOption.value : undefined,
          });
          toggleModal();
        }}
        placeholder={placeholder}
      />
    )}
    viewComponent={({ toggleModal }) => (
      <ActionComponent
        type="option"
        icon="info"
        text={'Status'}
        onClick={toggleModal}
      />
    )}
  />
);
